// extracted by mini-css-extract-plugin
export var header = "_ak-0";